import { Value } from "@gameonly/core";

const getValue = <T>(value: Value, type?: string): T | undefined => {
    if (value === undefined) {
      return undefined;
    }
    if (typeof value === "number" && type === "string") {
        return value.toString() as unknown as T 
    }
    return value as unknown as T;
  };

export default getValue;